export const API_HEADERS = {
  AUTHORIZATION: "Authorization",
  TENANT_ID: "x-tenant-id",
} as const;

export const API_ENDPOINTS = {
  HEALTH: "/health",
} as const;

export const API_STATUS = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  ACCOUNT_LOCKED: 406,
  MAINTENANCE: 503,
} as const;

export const API_ERROR_MESSAGE = {
  DEFAULT: "Có lỗi xảy ra. Vui lòng thử lại.",
  SESSION_EXPIRED: "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.",
  MAINTENANCE: "Hệ thống đang bảo trì. Vui lòng thử lại sau ít phút nữa.",
} as const;

export const AUTH_EVENT = {
  SESSION_EXPIRED: "erpgold:auth-session-expired",
} as const;
